import React, { useContext } from 'react';
import { Form, Header } from 'semantic-ui-react';
import { ItemCartContext } from '../../CatalogItemCart.context';
import './SpecialInstructions.css';
var defaultProps = {
  maxlength: 280
};
export default function SpecialInstructions(_ref) {
  var maxlength = _ref.maxlength;
  var _useContext = useContext(ItemCartContext),
    loading = _useContext.loading,
    specialInstructions = _useContext.specialInstructions,
    setSpecialInstructions = _useContext.setSpecialInstructions;
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "special-instructions"
  }, /*#__PURE__*/React.createElement(Header, {
    size: "small"
  }, "Special Instructions"), /*#__PURE__*/React.createElement(Form.TextArea, {
    maxlength: maxlength,
    value: specialInstructions,
    disabled: loading,
    onChange: function onChange(e, _ref2) {
      var value = _ref2.value;
      return setSpecialInstructions(value);
    }
  }));
}
SpecialInstructions.defaultProps = defaultProps;